<template>
    <div class="bg-base-200 h-screen-header rounded-xl relative">
        <!-- 设备选择菜单 - 绝对定位，不占用DOM空间 -->
        <div class="absolute top-4 right-4 z-10">
            <div class="flex items-center space-x-2">
                <button class="btn btn-sm tooltip tooltip-top" :class="{ 'btn-primary': currentDevice === 'local' }"
                    data-tip="音乐播放"
                    @click="switchDevice('local')">
                    <svg t="1711466361303" class="h-5 w-5 fill-current" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="2515" width="200" height="200">
                        <path
                            d="M768 436.906667v53.76a21.333333 21.333333 0 0 1-21.333333 21.333333h-42.666667a21.333333 21.333333 0 0 1-21.333333-21.333333v-11.52a115.626667 115.626667 0 0 0-64-100.693334c-7.68-4.266667-14.506667-9.386667-21.333334-14.08v384A161.28 161.28 0 0 1 426.666667 896a161.28 161.28 0 0 1-170.666667-149.333333 161.28 161.28 0 0 1 170.666667-149.333334 183.04 183.04 0 0 1 85.333333 20.906667V149.333333a21.333333 21.333333 0 0 1 21.333333-21.333333h42.666667a21.333333 21.333333 0 0 1 21.333333 21.333333v7.253334a113.92 113.92 0 0 0 61.013334 103.253333A197.12 197.12 0 0 1 768 436.906667z"
                            p-id="2516"></path>
                    </svg>
                </button>
                <button class="btn btn-sm tooltip tooltip-top" :class="{ 'btn-primary': currentDevice === 'xiaomi' }"
                    data-tip="小爱音箱"
                    @click="switchDevice('xiaomi')">
                    <svg t="1709777080693" class="w-5 h-5 fill-current" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="12709" width="200" height="200">
                        <path
                            d="M768 0a128 128 0 0 1 128 128v768a128 128 0 0 1-128 128H256a128 128 0 0 1-128-128V128a128 128 0 0 1 128-128h512z m0 64H256a64 64 0 0 0-64 64v768a64 64 0 0 0 64 64h512a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64z m-32 768v64h-448v-64h448zM512 256a256 256 0 1 1 0 512 256 256 0 0 1 0-512z m0 64a192 192 0 1 0 0 384 192 192 0 0 0 0-384z m0 128a64 64 0 1 1 0 128 64 64 0 0 1 0-128zM320 128v64H256V128h64z m448 0v64H704V128h64z">
                        </path>
                    </svg>
                </button>
                <!-- <button class="btn btn-sm tooltip tooltip-top" :class="{ 'btn-primary': currentDevice === 'dlna' }"
                    data-tip="DLNA设备"
                    @click="switchDevice('dlna')">
                    <svg class="w-5 h-5 fill-current" viewBox="0 0 1024 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg">
                        <path d="M128 256h768v512H128z m64 64v384h640V320H192z m160 128l192 96-192 96V448z" />
                    </svg>
                </button> -->
            </div>
        </div>

        <!-- 子路由内容 - 现在占用全部高度 -->
        <div class="h-full">
            <router-view />
        </div>
    </div>
</template>

<script>
export default {
    name: 'Queue',
    data() {
        return {
            currentDevice: 'local'
        }
    },
    created() {
        // 从 localStorage 读取上次选择的设备
        const savedDevice = localStorage.getItem('currentDevice')
        if (savedDevice) {
            this.currentDevice = savedDevice
            // 路由到保存的设备页面
            this.switchDevice(savedDevice)
        } else {
            // 初始化时检查当前路由，设置对应的设备类型
            this.setCurrentDeviceFromRoute()
        }
    },
    watch: {
        '$route'() {
            this.setCurrentDeviceFromRoute()
        }
    },
    methods: {
        switchDevice(deviceType) {
            this.currentDevice = deviceType
            // 保存设备选择到 localStorage
            localStorage.setItem('currentDevice', deviceType)

            // 根据设备类型路由到不同的子页面
            switch (deviceType) {
                case 'local':
                    this.$router.push({ name: 'playing-local' })
                    break
                case 'xiaomi':
                    this.$router.push({ name: 'playing-xiaomi' })
                    break
                case 'dlna':
                    this.$router.push({ name: 'playing-dlna' })
                    break
                default:
                    this.$router.push({ name: 'playing-local' })
            }
        },

        setCurrentDeviceFromRoute() {
            const routeName = this.$route.name
            if (routeName === 'playing-xiaomi') {
                this.currentDevice = 'xiaomi'
            } else if (routeName === 'playing-dlna') {
                this.currentDevice = 'dlna'
            } else {
                this.currentDevice = 'local'
            }
        }
    }
}
</script>
